import { pxToRem } from 'utils/convert';
import { InsightType } from '../domain';
import { InsightPanelSize } from './types';

export const INSIGHT_TITLES = {
  [InsightType.behavioral]: 'insights.behavioral',
  [InsightType.demographics]: 'insights.demographics',
  [InsightType.listUsage]: 'insights.listUsage.title',
};

export const INSIGHT_HEADER_WIDTHS: Record<InsightType, string | null> = {
  [InsightType.demographics]: pxToRem(365),
  [InsightType.behavioral]: pxToRem(125),
  [InsightType.listUsage]: null,
};

export const AUD_INSIGHTS_GRID_COL_COUNT = 4;

export const AUD_INSIGHTS_TABLES_TRUNCATED_LENGTH = 4;

export const DOCS_URL = 'https://support.iterable.com/hc/articles/7922758001940';

export const HIGHEST_CONVERSIONS_CAMPAIGNS_TABLES_LENGTH = 5;

export const MISSING_VALUE = 'unknown';
export const OTHER_VALUE = 'other';

export const INSIGHT_PANEL_SIZE = {
  [InsightPanelSize.small]: 'min-content',
  [InsightPanelSize.medium]: pxToRem(52),
};
